import { useEffect, useState, useRef } from "react";
import "./runAnalysis.css";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import {
  formatConfidence,
  // formatDateToShortString,
  // formatLift,
  formatSupport,
  // generateDynamicRecommendation,
  // generateRecommendationMessagesFromAssociation,
  // getCategoryNames,
  // getStrength,
  // getStrengthColor,
  // getStrengthThumb,
  // truncateDescription,
} from "../../../common/common";
import { useDispatch, useSelector } from "react-redux";
// import ProductBundles from "./ProductBundles/productBundles";
// import Rfm from "./tabs/rfm";
// import RecommendationsSection from "./RecommendationsSection";
// import TableDesign from "./tableDesign";
// import CustomerPopupWithOrder from "./customerPopupwithOrder";
// import UniqueCustomerModel from "./UniquecustomerPopup";
import {
  setAntecedentInfo,
  setAnalysisResult as setParentAnalysisResult,
  // setCurrentAnalysisData as setParentCurrentAnalysisData,
  setSearchQueryForItemsets as setSearchQueryForItemsetsParents,
  setSortBy as setSortByParents,
} from "../../../../store";
import AnalysisDetailsHistory from "./analysisDetailsHistory";
import AnalysisResultView from "./analysisResult/analysisResultView";

const HistoryAnalysis = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { order_details_id, reportId, start_date, end_date,isDefault } =
    location.state || {};

  const [showLoadingPage, setShowLoadingPage] = useState(false);
  const [isSingleOrderExclude, setIsSingleOrderExclude] = useState(true);
  const [analysesId, setAnalysisId] = useState(null);
  const [loadingAnalysisResults, setLoadingAnalysisResults] = useState(false);
  const [currentAnalysisData, setCurrentAnalysisData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [mainCompleteAnalysisResult, setMainCompleteAnalysisResult] = useState(
    []
  );
  const [supportFilteredAnalysisResult, setSupportFilteredAnalysisResult] =
    useState([]);
  const [displayAnalysisResult, setDisplayAnalysisResult] = useState([]);
  const [supportFilter, setSupportFilter] = useState(null);
  const [selectedCombo, setSelectedCombo] = useState(1);
  const [countItemSet, setCountItemSet] = useState({
    item_set_1: 0,
    item_set_2: 0,
    item_set_3: 0,
    item_set_4: 0,
    item_set_all: 0,
  });
  const [sortBy, setSortBy] = useState("hl");
  const [uniqueProducts, setUniqueProducts] = useState(0);
  const [highestLiftRule, setHighestLiftRule] = useState(0);
  const [searchQueryForItemsets, setSearchQueryForItemsets] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [
    analysisDetailsHistoryOriginalData,
    setAnalysisDetailsHistoryOriginalData,
  ] = useState([]);
  const [analysisDetailsHistory, setAnalysisDetailsHistory] = useState([]);
  const [selectDesign, setSelectDesign] = useState(1);
  const [highestConfidenceRule, setHighestConfidenceRule] = useState("");
  const [customeValueData, setCustomerValueData] = useState({});
  const [productsBundles, setProductsBundles] = useState([]);
  const [favoriteSkuResponseList,setFavoriteSkuResponseList] = useState([]);

  const [switchTab, setSwitchTab] = useState(1);

  const getAnlysisResultByAnalysisDetailsId = async () => {
    try {
      setIsLoading(true);
	  const favoriteSkuResponse = await fetch(
        `${process.env.REACT_APP_API_END_POINT}/data-analysis/analysis-sku-favorite?analysis_details_id=${analysesId}&order_details_id=${order_details_id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
	  const favoriteSku = await favoriteSkuResponse.json();
	  setFavoriteSkuResponseList(favoriteSku.data)
	//   console.log(favoriteSku.data,"favoriteSku")

      const response = await fetch(
        `${process.env.REACT_APP_ORDER_ANALYSIS_RESULT}?analysis_details_id=${analysesId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const newResponse = await response.json();
      if (!response.ok) {
        if (newResponse?.detail?.isExpireToken) {
          const token = localStorage.removeItem("token");
          const user = localStorage.removeItem("userInfo");
          navigate("/login");
        }
        throw new Error(
          newResponse.detail?.message || "Failed to fetch analysis history"
        );
      }

      dispatch(setParentAnalysisResult(newResponse.data));

      const newResponseWithModify = newResponse.data.map((data) => {
        let antecedentSkus = [];
        let consequentSkus = [];

        data.antecedents.forEach((sku) => {
          antecedentSkus.push(sku.sku);
        });

        data.consequent.forEach((sku) => {
          consequentSkus.push(sku.sku);
        });

        const modifiedData = {
          ...data,
          totalPurchasedTogether: Math.round(
            data.support * currentAnalysisData?.totalOrder
          ),
          antecedentPurchasedTogether: Math.round(
            data.antecedent_support * currentAnalysisData?.totalOrder
          ),
          consequnetPurchasedTogether: Math.round(
            data.consequent_support * currentAnalysisData?.totalOrder
          ),
          antecedentSkus,
          consequentSkus,
          allSkus: [...antecedentSkus, ...consequentSkus],
        };

        // console.log(data.antecedent_support,currentAnalysisData?.totalOrder,(data.antecedent_support * currentAnalysisData?.totalOrder),"antecedentPurchasedTogether",antecedentSkus)

        return modifiedData;
      });
      
      setMainCompleteAnalysisResult(newResponseWithModify);
      setSupportFilteredAnalysisResult(newResponseWithModify);

      
      toast.success("Analysis Result fetched successfully!", {
        position: "top-right",
        autoClose: 3000,
      });
    } catch (err) {
      let itemSetCounter = {
        item_set_1: 0,
        item_set_2: 0,
        item_set_3: 0,
        item_set_4: 0,
        item_set_all: 0,
      };
      if(switchTab !==3){
        setCountItemSet(itemSetCounter);
      }
      toast.error(err.message, {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      setIsLoading(false);
      setSelectedCombo(1);
      setSelectDesign(1);
      setCurrentPage(1);
    }
  };

  useEffect(() => {
    if (analysesId) {
      if (mainCompleteAnalysisResult.length === 0) {
        getAnlysisResultByAnalysisDetailsId();
        if(isDefault){
          setSwitchTab(4)
        }
      }
    }
  }, [analysesId]);

  useEffect(() => {
    if (mainCompleteAnalysisResult.length === 0 || supportFilter === null) {
      return;
    }


    const filterAnalysisDataWithSupport = mainCompleteAnalysisResult.filter(
      (result) => {
        let support = formatSupport(result.support);

		let totalPurchasedTogether = Math.round(
            supportFilter/100 * currentAnalysisData?.totalOrder
          )

		// console.log(support,"support",result.support,totalPurchasedTogether,result.totalPurchasedTogether)
        return result.totalPurchasedTogether >= totalPurchasedTogether;
        // return support >= supportFilter;

      }
    );
    setSupportFilteredAnalysisResult(filterAnalysisDataWithSupport);

    const analysisDataNew = { ...currentAnalysisData };
    analysisDataNew.totalItemSets = filterAnalysisDataWithSupport.length;
    
    setCurrentAnalysisData(analysisDataNew);
  }, [supportFilter, mainCompleteAnalysisResult]);


  useEffect(() => {
    const productFilterData = [...supportFilteredAnalysisResult];
    const productBundles = productFilterData.filter((data) => {
      let minSupport = formatConfidence(currentAnalysisData?.min_support);

      const support = data.support * 100; // Keep it as a number
      const confidence = data.confidence * 100; // Keep it as a number
      const lift = data.lift;

      if (minSupport <= 1) {
        if (supportFilter) {
          if (supportFilter <= 1) {
            return lift > 3 && support >= 1 && confidence >= 25;
          } else {
            return lift > 3 && support >= supportFilter && confidence >= 25;
          }
        }
        return lift > 3 && support >= 1 && confidence >= 25;
      } else {
        if (supportFilter) {
          if (supportFilter <= minSupport) {
            return lift > 3 && support >= minSupport && confidence >= 25;
          } else {
            return lift > 3 && support >= supportFilter && confidence >= 25;
          }
        }
        return lift > 3 && support >= minSupport && confidence >= 25;
      }
    });


    setProductsBundles(productBundles);
  }, [supportFilteredAnalysisResult]);

  useEffect(() => {

    let filtered = [...supportFilteredAnalysisResult];
    const query = searchQueryForItemsets.toLowerCase().trim();

    // 1. Search filter
    if (query) {
      filtered = filtered.filter((item) => {
        const items = [...item.antecedents];
        const isSKU = items.some((sku) => sku?.sku.toLowerCase() === query);
        const isProductName = items.some((sku) =>
          sku?.product_title?.toLowerCase().includes(query)
        );
        return isSKU || isProductName;
      });
    }

    let itemSetCounter = {
      item_set_1: 0,
      item_set_2: 0,
      item_set_3: 0,
      item_set_4: 0,
      item_set_all: 0,
    };
    filtered.map((result) => {
      const antecedentsLength = result.antecedents.length;
      // Count logic
      if (antecedentsLength === 1) itemSetCounter.item_set_1++;
      if (antecedentsLength === 2) itemSetCounter.item_set_2++;
      if (antecedentsLength === 3) itemSetCounter.item_set_3++;
      if (antecedentsLength === 4) itemSetCounter.item_set_4++;
      if (true) itemSetCounter.item_set_all++;
    });
    if(switchTab !==3){
      setCountItemSet(itemSetCounter);
    }


    let filteredResults = filtered.filter((result) => {
      let antecedentsLength = result.antecedents.length;
      if (selectedCombo !== 0 && selectedCombo === antecedentsLength) {
        return true;
      }
      if (selectedCombo === 0) {
        return true;
      }
    });


    const highestConfidenceRules = filteredResults.reduce(
      (max, rule) => (rule.confidence > max.confidence ? rule : max),
      filteredResults[0]
    );
    const highestLiftRules = filteredResults.reduce(
      (max, rule) => (rule.lift > max.lift ? rule : max),
      filteredResults[0]
    );
    setHighestConfidenceRule(highestConfidenceRules?.confidence || 0);
    setHighestLiftRule(highestLiftRules?.lift || 0);

    const uniqueSkus = new Set();
    filteredResults.forEach((item) => {
      item.antecedents.forEach((data) => uniqueSkus.add(data.sku));
      item.consequent.forEach((data) => uniqueSkus.add(data.sku));
    });
    const uniqueProductCount = uniqueSkus.size;
    setUniqueProducts(uniqueProductCount);

    let newFilter = [...filteredResults];

    // 2. Sort correctly for all cases
    switch (sortBy) {
      case "hl": // High lift
        newFilter = [...newFilter].sort(
          (a, b) => Number(b.lift) - Number(a.lift)
        );
        break;
      case "ll": // Low lift
        newFilter = [...newFilter].sort(
          (a, b) => Number(a.lift) - Number(b.lift)
        );
        break;
      case "hs": // High days
        newFilter = [...newFilter].sort((a, b) => b.support - a.support);
        break;
      case "ls": // Low days
        newFilter = [...newFilter].sort((a, b) => a.support - b.support);
        break;
      case "hc": // High days
        newFilter = [...newFilter].sort((a, b) => b.confidence - a.confidence);
        break;
      case "lc": // Low days
        newFilter = [...newFilter].sort((a, b) => a.confidence - b.confidence);
        break;
      case "strong":
        newFilter = [...newFilter].sort((a, b) => {
          const MIN_SUPPORT_PCT = 0.01;
          const MIN_CONFIDENCE_PCT = 50.0;

          const supportA = a.support * 100;
          const confidenceA = a.confidence * 100;
          const liftA = a.lift;
          const isStrongA =
            supportA >= MIN_SUPPORT_PCT &&
            confidenceA >= MIN_CONFIDENCE_PCT &&
            liftA > 1.0;

          const supportB = b.support * 100;
          const confidenceB = b.confidence * 100;
          const liftB = b.lift;
          const isStrongB =
            supportB >= MIN_SUPPORT_PCT &&
            confidenceB >= MIN_CONFIDENCE_PCT &&
            liftB > 1.0;

          if (isStrongA && !isStrongB) return -1; // A comes first
          if (!isStrongA && isStrongB) return 1; // B comes first
          return 0; // No preference if both same
        });
        break;
      case "weak":
        newFilter = [...newFilter].sort((a, b) => {
          const MIN_SUPPORT_PCT = 0.01;
          const MIN_CONFIDENCE_PCT = 50.0;

          const supportA = a.support * 100;
          const confidenceA = a.confidence * 100;
          const liftA = a.lift;
          const isStrongA =
            supportA >= MIN_SUPPORT_PCT &&
            confidenceA >= MIN_CONFIDENCE_PCT &&
            liftA > 1.0;

          const supportB = b.support * 100;
          const confidenceB = b.confidence * 100;
          const liftB = b.lift;
          const isStrongB =
            supportB >= MIN_SUPPORT_PCT &&
            confidenceB >= MIN_CONFIDENCE_PCT &&
            liftB > 1.0;

          if (!isStrongA && isStrongB) return -1; // A is weak, comes first
          if (isStrongA && !isStrongB) return 1; // B is weak, comes first
          return 0; // Both same strength
        });
        break;
      default:
        break;
    }

    setDisplayAnalysisResult(newFilter);
  }, [
    selectedCombo,
    sortBy,
    searchQueryForItemsets,
    supportFilteredAnalysisResult,
    switchTab
  ]);

  if (showLoadingPage) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-50">
        <div className="flex flex-col items-center">
          {/* Spinner */}
          <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mb-4" />
          {/* Loading text */}
          <h1 className="text-xl font-medium text-gray-700">
            Loading, please wait...
          </h1>
        </div>
      </div>
    );
  }

  const design = (
    <div className="flex min-h-screen">
      <AnalysisDetailsHistory
        order_details_id={order_details_id}
        isSingleOrderExclude={isSingleOrderExclude}
        setIsSingleOrderExclude={setIsSingleOrderExclude}
        setAnalysisId={setAnalysisId}
        analysesId={analysesId}
        loadingAnalysisResults={loadingAnalysisResults}
        setCurrentAnalysisData={setCurrentAnalysisData}
        switchTab={switchTab}
        analysisDetailsHistoryOriginalData={analysisDetailsHistoryOriginalData}
        setAnalysisDetailsHistoryOriginalData={
          setAnalysisDetailsHistoryOriginalData
        }
        analysisDetailsHistory={analysisDetailsHistory}
        setAnalysisDetailsHistory={setAnalysisDetailsHistory}
        setSupportFilter={setSupportFilter}
        setShowLoadingPage={setShowLoadingPage}
        setSwitchTab={setSwitchTab}
        setMainCompleteAnalysisResult={setMainCompleteAnalysisResult}
        setSupportFilteredAnalysisResult={setSupportFilteredAnalysisResult}
        setDisplayAnalysisResult={setDisplayAnalysisResult}
        setProductsBundles={setProductsBundles}
        isDefault={isDefault}
      />

      <AnalysisResultView
        switchTab={switchTab}
        setSwitchTab={setSwitchTab}
        currentAnalysisData={currentAnalysisData}
        reportId={reportId}
        uniqueProducts={uniqueProducts}
        highestLiftRule={highestLiftRule}
        displayAnalysisResult={displayAnalysisResult}
        start_date={start_date}
        end_date={end_date}
        searchQueryForItemsets={searchQueryForItemsets}
        setSearchQueryForItemsets={setSearchQueryForItemsets}
        supportFilter={supportFilter}
        setSupportFilter={setSupportFilter}
        selectedCombo={selectedCombo}
        setSelectedCombo={setSelectedCombo}
        countItemSet={countItemSet}
        sortBy={sortBy}
        setSortBy={setSortBy}
        setCurrentPage={setCurrentPage}
        currentPage={currentPage}
        analysisDetailsHistory={analysisDetailsHistory}
        isLoading={isLoading}
        selectDesign={selectDesign}
        productBundlesData={productsBundles}
        order_details_id={order_details_id}
        isSingleOrderExclude={isSingleOrderExclude}
		    favoriteSkuResponseList={favoriteSkuResponseList}
        setCountItemSet={setCountItemSet}
        isDefault={isDefault}
        
      />
    </div>
  );

  return design;
};

export default HistoryAnalysis;
